import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ta-type-radio',
    templateUrl: './ta-type-radio.component.html',
    styleUrls: ['./ta-type-radio.component.scss'],
})
export class TaTypeRadioComponent {
    @Input() callbackData: any;

    radioChanged(event: any) {
        console.log(this.callbackData);

        if (this.callbackData) {
            this.callbackData[0].callback(
                this.callbackData[0].arg[0],
                event.checked,
                this.callbackData[0].arg[1],
                this.callbackData[0].arg[2]
            );
        }
    }
}
